/**
 * @generated SignedSource<<2da135e56e9e45c2e5f481821656e304>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type jqlBuilder_issueNavigator_JQLBuilderWrapper_groupResults$data = {
  readonly errors: ReadonlyArray<{
    readonly extensions: ReadonlyArray<{
      readonly statusCode: number | null | undefined;
    }> | null | undefined;
    readonly message: string | null | undefined;
  }> | null | undefined;
  readonly " $fragmentType": "jqlBuilder_issueNavigator_JQLBuilderWrapper_groupResults";
};
export type jqlBuilder_issueNavigator_JQLBuilderWrapper_groupResults$key = {
  readonly " $data"?: jqlBuilder_issueNavigator_JQLBuilderWrapper_groupResults$data;
  readonly " $fragmentSpreads": FragmentRefs<"jqlBuilder_issueNavigator_JQLBuilderWrapper_groupResults">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "jqlBuilder_issueNavigator_JQLBuilderWrapper_groupResults",
  "selections": [
    {
      "concreteType": "QueryError",
      "kind": "LinkedField",
      "name": "errors",
      "plural": true,
      "selections": [
        {
          "kind": "LinkedField",
          "name": "extensions",
          "plural": true,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "statusCode"
            }
          ]
        },
        {
          "kind": "ScalarField",
          "name": "message"
        }
      ]
    }
  ],
  "type": "JiraSpreadsheetGroupConnection"
};

(node as any).hash = "30cd518272beee6c712a219e1b78cd63";

export default node;
